<template>
    <div class="loading"
         v-loading="loading"
         element-loading-text="校验用户中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"></div>
</template>

<script>
import {mtRedirectUrl} from "@/api/index.js"

export default {
    name: "auth",
    data() {
        return {
            loading: true
        }
    },
    mounted() {
        console.log(this.$route)
        let form = {...this.$route.query, userId: sessionStorage.getItem('userId')}
        console.log('mtRedirectUrlForm', form)
        mtRedirectUrl(form).then(result => {
            console.log(result)
            if (result.data.code !== 200) {
                this.$message.error(result.data.msg)
                setTimeout(() => {
                    this.$router.push("/login")
                })
                return;
            }
            let data = result.data.data;
            this.$store.commit("setMtToken", data.accessToken);
            console.log(data)
            this.$store.commit("setMTConfig", data);
            for (let key in data) {
                localStorage.setItem(key, data[key]);
            }
            setTimeout(() => {
                if (this.$route.query.customPath) {
                    this.$router.push({path: `/${this.$route.query.customPath}`, query: {...this.$route.query}})
                } else {
                    this.$router.push("/user")
                }

            }, 500)
        })
    }
}
</script>

<style scoped>
.loading {
    width: 100%;
    height: 100vh;
}
</style>
